// @ts-nocheck
import { JxsComponent } from "@jxs/component";

class JxsProductCardCarousel extends JxsComponent {

  #swiper = null;

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.initSwiper();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#swiper.destroy();
  }

  initSwiper() {
    const group = this.refs.swiper.querySelector('.jxs-block-rich-product-card-group');
    group?.classList.add('swiper-wrapper');
    group?.querySelectorAll('.jxs-block-rich-product-card').forEach(card => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      slide.append(card);
      group.append(slide);
    });

    let desktopslidesPerView = 1;
    let mobileslidesPerView = 1;
    let spaceBetween = this.querySelector('.card--box-shadow') && !this.getDataset('showNext') ? 0 : 10;
    if (this.getDataset('showNext')) {
      desktopslidesPerView = 1.2;
      mobileslidesPerView = 1.1;
    }
    this.#swiper = new window.Swiper(this.refs.swiper, {
      slidesPerView: mobileslidesPerView,
      spaceBetween: spaceBetween,
      breakpoints: {
        768: {
          spaceBetween: spaceBetween * 2,
          slidesPerView: desktopslidesPerView
        }
      },
      
      pagination: {
        el: '.swiper-pagination',
        enabled: true,
        clickable: true,
        type: 'bullets'
      }
    });
  }
}
customElements.define('jxs-product-card-carousel', JxsProductCardCarousel);